import { Directive } from '@angular/core';
import { StoreComponentDef } from '@df/catalog-ui/store/store.component.def';
import { IModelDataV3WithUrl, Model } from '@df/catalog/model';
import { IStoreDataV3, Store } from '@df/catalog/store/store';

@Directive()
export class StoreViewComponentDef<T extends Store = Store<IStoreDataV3>> extends StoreComponentDef<T> {
    override verbosity = 3;

    protected assignModelToMeta() {
        this.app.meta.model = <Model<IModelDataV3WithUrl>>this.model;
    }
}
